import ContactForm from '/components/pages/common/Contact/components/ContactForm'
import styles from './styles.module.scss'
import { useRouter } from 'next/router'

const InquiryModal = ({ name, translations, form }) => {
  const router = useRouter()

  return (
    <div>
      <h2 className={styles.title}>{`${
        translations.popup.title[router.locale]
      } ${name}`}</h2>

      <p className={styles.description}>
        {translations.popup.contact[router.locale]}
      </p>

      <ContactForm
        translations={translations}
        variant={['dark']}
        route="real-estate/contact-email"
        {...form}
        thankYou={{ url: '/real-estate/search' }}
      />
    </div>
  )
}

export default InquiryModal
